import React from "react";
import FormLabel from "./FormLabel";
import { Multiselect } from "multiselect-react-dropdown";

const MultiSelection = (props) => {
  // state = {};
  // console.log(props, "test")

  return (
    <div className="w-full">
      <FormLabel name="Ms1" text={props.label} />

      <div className="mt-2 w-full flex rounded-lg shadow-sm focus-within:ring-1 focus-within:ring-blue-300 dark:text-white">
        <div className="relative flex items-center w-full gap-2 bg-white border border-gray-200 rounded-lg px-3 py-1.5 dark:bg-white/5 dark:border-gray-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 30"
            className="h-4 w-4 text-blue-400 mt-0.5"
            fill="currentColor"
          >
            <path d="M 20 4 C 18.706841 4 17.604859 4.84267 17.1875 6 L 4 6 A 1.0001 1.0001 0 1 0 4 8 L 17.1875 8 C 17.604859 9.15733 18.706841 10 20 10 C 21.293159 10 22.395141 9.15733 22.8125 8 L 26 8 A 1.0001 1.0001 0 1 0 26 6 L 22.8125 6 C 22.395141 4.84267 21.293159 4 20 4 z M 20 6 C 20.54383 6 20.958426 6.4088115 20.988281 6.9433594 A 1.0001 1.0001 0 0 0 20.988281 7.0585938 C 20.957487 7.5921595 20.543157 8 20 8 C 19.45617 8 19.041574 7.5911885 19.011719 7.0566406 A 1.0001 1.0001 0 0 0 19.011719 6.9414062 C 19.042513 6.4078405 19.456843 6 20 6 z M 12 12 C 10.706841 12 9.6048586 12.84267 9.1875 14 L 4 14 A 1.0001 1.0001 0 1 0 4 16 L 9.1875 16 C 9.6048586 17.15733 10.706841 18 12 18 C 13.293159 18 14.395141 17.15733 14.8125 16 L 26 16 A 1.0001 1.0001 0 1 0 26 14 L 14.8125 14 C 14.395141 12.84267 13.293159 12 12 12 z M 12 14 C 12.54383 14 12.958426 14.408812 12.988281 14.943359 A 1.0001 1.0001 0 0 0 12.988281 15.058594 C 12.957487 15.592159 12.543157 16 12 16 C 11.45617 16 11.041574 15.591188 11.011719 15.056641 A 1.0001 1.0001 0 0 0 11.011719 14.941406 C 11.042513 14.407841 11.456843 14 12 14 z M 16 20 C 14.706841 20 13.604859 20.84267 13.1875 22 L 4 22 A 1.0001 1.0001 0 1 0 4 24 L 13.1875 24 C 13.604859 25.15733 14.706841 26 16 26 C 17.293159 26 18.395141 25.15733 18.8125 24 L 26 24 A 1.0001 1.0001 0 1 0 26 22 L 18.8125 22 C 18.395141 20.84267 17.293159 20 16 20 z M 16 22 C 16.54383 22 16.958426 22.408812 16.988281 22.943359 A 1.0001 1.0001 0 0 0 16.988281 23.058594 C 16.957487 23.592159 16.543157 24 16 24 C 15.45617 24 15.041574 23.591188 15.011719 23.056641 A 1.0001 1.0001 0 0 0 15.011719 22.941406 C 15.042513 22.407841 15.456843 22 16 22 z" />
          </svg>

          <div className="w-full">
            <Multiselect
              id={props.id}
              options={props.data}
              isObject={false}
              showCheckbox={true}
              selectedValues={props.selectedValues}
              onSelect={props.onSelect}
              onRemove={props.onRemove}
              placeholder={props.placeholder}
              avoidHighlightFirstOption={true}
              style={{
                chips: {
                  background: "#3B82F6",
                  whiteSpace: "normal",
                  fontWeight: "bold",
                },
                searchBox: {
                  background: "transparent",
                  border: "none",
                  boxShadow: "none",
                  padding: 0,
                  width: "100%",
                },
                inputField: {
                  paddingLeft: 0,
                  width: "100%",
                },
                optionContainer: {
                  background: "white",
                  color: "black",
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>

  );
};

export default MultiSelection;
